import React from 'react';
import Image from 'next/image';
import {
  EmailIconPrimary,
  LocationIconPrimary,
  PhoneIconPrimary,
  ZaloIconPrimary,
} from '@/assets/icons';
import { SEOHead } from '@/components/Shared';
import {
  COMPANY_ADDRESSES,
  PRIMARY_ADDRESS,
  SECONDARY_ADDRESSES,
  getCompanyAddressesJsonLd,
} from '@/constants/companyInfo';

const siteUrl = 'https://www.truongthofood.vn';

const [secondaryAddress] = SECONDARY_ADDRESSES;

const contactDescriptionBase =
  'Liên hệ với Trường Thọ Food để đặt hàng trứng gà tươi và trứng bóc vỏ sẵn. Hotline: 083 419 4986. Email: truongthofood68@gmail.com.';

const contactDescription =
  `${contactDescriptionBase} Địa chỉ: ${PRIMARY_ADDRESS.fullAddress}` +
  (secondaryAddress
    ? `. Chi nhánh: ${secondaryAddress.fullAddress}`
    : '');

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/contact`,
  name: 'Trường Thọ Food',
  image: `${siteUrl}/logo-hori.png`,
  description:
    'Công ty chuyên cung cấp trứng gà tươi và trứng bóc vỏ sẵn chất lượng cao',
  url: siteUrl,
  telephone: '+84-83-419-4986',
  email: 'truongthofood68@gmail.com',
  address: getCompanyAddressesJsonLd(),
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '10.9284',
    longitude: '106.7507',
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    opens: '08:00',
    closes: '17:00',
  },
  priceRange: '$$',
  servesCuisine: 'Vietnamese Food',
};

const Contact = () => {
  return (
    <>
      <SEOHead
        title="Liên Hệ - Trường Thọ Food | Hotline: 083 419 4986"
        description={contactDescription}
        keywords="liên hệ Trường Thọ, hotline trứng gà, đặt hàng trứng gà, số điện thoại Trường Thọ, địa chỉ Trường Thọ Food"
        image={`${siteUrl}/banner.png`}
        url={`${siteUrl}/contact`}
        structuredData={localBusinessSchema}
      />
      <div>
      <div className="flex w-full justify-center py-16 md:py-[84px] relative">
        <Image
          src={
            'https://images.unsplash.com/photo-1629476957643-9c3ee7b4e231?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
          }
          alt="Banner trang liên hệ - Trường Thọ Food - Hotline: 083 419 4986"
          fill
          style={{ objectFit: 'cover' }}
          className="absolute top-0 left-0 w-full h-full"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>
        <p className="text-[24px] md:text-[32px] font-bold text-white z-10 relative uppercase">
          Liên hệ
        </p>
      </div>
      <div className="container w-full flex flex-col gap-5 py-8 md:py-12">
        <div className="flex w-full justify-center">
          <p className="text-[16px] md:text-[24px] font-medium text-center">
            Liên hệ ngay với chúng tôi để có mức giá hấp dẫn nhất và dịch vụ
            chăm sóc khách hàng tốt nhất
          </p>
        </div>
        <div className="flex md:flex-row flex-col gap-5 w-full">
          <div className="w-full flex-col flex border-2 border-gray-200 p-5 justify-between rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
            <div className="flex flex-col gap-4">
              <EmailIconPrimary />
              <p className="font-medium text-[18px]">Email</p>
              <p className="underline">truongthofood68@gmail.com</p>
            </div>
            <a
              href="mailto:truongthofood68@gmail.com"
              className="bg-primary text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary inline-block text-center"
            >
              Gửi Email
            </a>
          </div>
          <div className="w-full flex-col flex border-2 border-gray-200 p-5 justify-between rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
            <div className="flex flex-col gap-4">
              <PhoneIconPrimary />
              <p className="font-medium text-[18px]">Hotline</p>
              <p className="underline">083 419 4986</p>
            </div>
            <a
              href="tel:0834194986"
              className="bg-primary text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary inline-block text-center"
            >
              Gọi ngay
            </a>
          </div>
          <div className="w-full flex-col flex border-2 border-gray-200 p-5 justify-between rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
            <div className="flex flex-col gap-4">
              <LocationIconPrimary />
              <p className="font-medium text-[18px]">Địa chỉ</p>
              <div className="flex flex-col gap-1">
                {COMPANY_ADDRESSES.map((address) => (
                  <p key={address.id} className="underline">
                    {address.label
                      ? `${address.label}: ${address.fullAddress}`
                      : address.fullAddress}
                  </p>
                ))}
              </div>
            </div>
            <button className="bg-primary text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary">
              Xem bản đồ
            </button>
          </div>
        </div>

        <div className="w-full border-2 border-gray-200 rounded-2xl overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.462263816798!2d106.75067327532068!3d10.928411556371374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d9ba0594d31d%3A0x8f4d20a6a75ce6be!2zNzUgVsWpbmcgVGhp4buHbiwgVMOibiDEkMO0bmcgSGnhu4dwLCBExKkgQW4sIELDrG5oIETGsMahbmcsIFZpZXRuYW0!5e0!3m2!1sen!2s!4v1766288828363!5m2!1sen!2s"
            className="w-full h-[350px] md:h-[500px]"
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default Contact;
